import { QueryKey, useMutation, useQueryClient } from "@tanstack/react-query";
import type { CrudType } from "../../utils/useCrud/CrudType";

export const getUsePut =
  <TRequest extends CrudType, T extends CrudType>(
    queryKey: (item: TRequest) => QueryKey,
    sendPutItem: (item: TRequest) => Promise<T>
  ) =>
  () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: (item: TRequest) => sendPutItem(item),
      onMutate: async (item) => {
        await queryClient.cancelQueries(queryKey(item));
        queryClient.setQueryData(queryKey(item), (prevItems: T[] = []) =>
          prevItems.map((prevItem) =>
            prevItem.id === item.id ? { ...prevItem, ...item } : prevItem
          )
        );
      },
    });
  };
